import React from "react";
import { MDBRow, MDBCol } from 'mdbreact';
//import { HorizontalBar } from 'react-chartjs-2';
//import { MDBContainer } from "mdbreact";

import CanvasJSReact from '../../Assets/canvasjs.react'
var CanvasJSChart = CanvasJSReact.CanvasJSChart;
class CampaignGraph extends React.Component {
    constructor(props) {
        super()

    }
    render() {
        const options = {
            animationEnabled: true,
            theme: "dark2",
            //backgroundColor: "#5C5959",
            height: 600,
            axisX: {
                title: "Distributor",
                reversed: true,
                interval: 1,
                labelFontSize: 12
            },
            axisY: {
                title: "Percentage of Goal",
                interval: 10,
                labelFontSize: 12,
                labelFormatter: function (e) {
                    return e.value + '%';
                }
            },
            data: [{
                type: "bar",
                indexLabel: "{y}",
                indexLabelFontSize: 12,
                indexLabelFontStyle: "bold",
                dataPoints: this.props.dataPoints
                //dataPoints: [
                //    { y: 2200000000, label: "Facebook", color: "RoyalBlue" },
                //    { y: 1800000000, label: "YouTube" },
                //    { y: 800000000, label: "Instagram" },
                //    { y: 563000000, label: "Qzone" },
                //    { y: 376000000, label: "Weibo" },
                //    { y: 336000000, label: "Twitter" },
                //    { y: 330000000, label: "Reddit" }
                //]
            }]
        }

        return (
            <div>
                <div>
                    <MDBRow className="justify-content-center">
                        <div style={{
                            backgroundColor: '#CB3434',
                            borderRadius: "50%",
                            width: 30,
                            height: 30,
                            //textAlign: "center"
                        }}>
                            
                        </div>
                        <p style={{ fontWeight: "bold", fontSize: "12px", paddingTop: "5px" }}>&nbsp;0 - 10%&nbsp;</p>
                        <div style={{
                            backgroundColor: '#F39E49',
                            borderRadius: "50%",
                            width: 30,
                            height: 30,
                            //textAlign: "center"
                        }}>

                        </div>
                        <p style={{ fontWeight: "bold", fontSize: "12px", paddingTop: "5px" }}>&nbsp;11 - 20%&nbsp;</p>
                        <div style={{
                            backgroundColor: '#F149F3',
                            borderRadius: "50%",
                            width: 30,
                            height: 30,
                            //textAlign: "center"
                        }}>

                        </div>
                        <p style={{ fontWeight: "bold", fontSize: "12px", paddingTop: "5px" }}>&nbsp;21 - 30%&nbsp;</p>
                        <div style={{
                            backgroundColor: '#49F3B5',
                            borderRadius: "50%",
                            width: 30,
                            height: 30,
                            //textAlign: "center"
                        }}>

                        </div>
                        <p style={{ fontWeight: "bold", fontSize: "12px", paddingTop: "5px" }}>&nbsp;31 - 40%&nbsp;</p>
                        <div style={{
                            backgroundColor: '#F3F149',
                            borderRadius: "50%",
                            width: 30,
                            height: 30,
                            //textAlign: "center"
                        }}>

                        </div>
                        <p style={{ fontWeight: "bold", fontSize: "12px", paddingTop: "5px" }}>&nbsp;41 - 50%&nbsp;</p>
                        <div style={{
                            backgroundColor: '#9C49F3',
                            borderRadius: "50%",
                            width: 30,
                            height: 30,
                            //textAlign: "center"
                        }}>

                        </div>
                        <p style={{ fontWeight: "bold", fontSize: "12px", paddingTop: "5px" }}>&nbsp;51 - 60%&nbsp;</p>
                        <div style={{
                            backgroundColor: '#4987F3',
                            borderRadius: "50%",
                            width: 30,
                            height: 30,
                            //textAlign: "center"
                        }}>

                        </div>
                        <p style={{ fontWeight: "bold", fontSize: "12px", paddingTop: "5px" }}>&nbsp;61 - 70%&nbsp;</p>
                        <div style={{
                            backgroundColor: '#F349A0',
                            borderRadius: "50%",
                            width: 30,
                            height: 30,
                            //textAlign: "center"
                        }}>

                        </div>
                        <p style={{ fontWeight: "bold", fontSize: "12px", paddingTop: "5px" }}>&nbsp;71 - 80%&nbsp;</p>
                        <div style={{
                            backgroundColor: '#6049F3',
                            borderRadius: "50%",
                            width: 30,
                            height: 30,
                            //textAlign: "center"
                        }}>

                        </div>
                        <p style={{ fontWeight: "bold", fontSize: "12px", paddingTop: "5px" }}>&nbsp;81 - 90%&nbsp;</p>
                        <div style={{
                            backgroundColor: '#6ADB00',
                            borderRadius: "50%",
                            width: 30,
                            height: 30,
                            //textAlign: "center"
                        }}>

                        </div>
                        <p style={{ fontWeight: "bold", fontSize: "12px", paddingTop: "5px"}}>&nbsp;91 - 100+%&nbsp;</p>
                    </MDBRow>
                </div>
                <div style={{ height: '100vh' }}>
                    <CanvasJSChart options={options}
                    /* onRef={ref => this.chart = ref} */
                    />
                    {/*You can get reference to the chart instance as shown above using onRef. This allows you to access all chart properties and methods*/}
                </div>
            </div>
        );
        //const data = {
        //    labels: this.props.labels,
        //    datasets: [
        //        {
        //            label: 'Percentage Of Goal',
        //            backgroundColor: 'rgba(247,53,221,1)',
        //            borderColor: 'rgba(247,53,222,1)',
        //            borderWidth: 1,
        //            hoverBackgroundColor: 'rgba(249,92,228,0.4)',
        //            hoverBorderColor: 'rgba(249,92,228,1)',
        //            data: this.props.data1
        //        }
        //        //, {
        //        //    label: 'Progress',
        //        //    backgroundColor: 'rgba(9,176,209,1)',
        //        //    borderColor: 'rgba(9,176,208,1)',
        //        //    borderWidth: 1,
        //        //    hoverBackgroundColor: 'rgba(9,176,209,0.4)',
        //        //    hoverBorderColor: 'rgba(9,176,208,1)',
        //        //    data: this.props.data2

        //        //}
        //    ]
        //};
        //return (
        //    <div>
        //        <HorizontalBar data={data} options={{ responsive: true }}/>

        //    </div>
        //);
    }
}

export default CampaignGraph;